import { STORY_EPISODES, STORY_MOMENT_LABELS, type StoryEpisode } from '@hyakki/core/data/stories';
import { STORY_CUES, type StoryCue } from '@hyakki/core/data/story-moments';
import { COUNTRIES, PROVINCE_BY_ID } from '@hyakki/core/meta/provinces';

export interface StorySection {
  id: string;
  episode: StoryEpisode;
  cue?: StoryCue;
  number: string;
  title: string;
  region: string;
  lines: StoryEpisode['lines'];
}
export type StoryProgress = Record<string, { lineId: string; complete: boolean }>;

/** ゲームへの挿入単位と、物語帳で読む単位を共通にする。台詞IDは変更しない。 */
export const STORY_SECTIONS: StorySection[] = STORY_EPISODES.flatMap(episode => {
  const cues = STORY_CUES.filter(c => c.episodeId === episode.id);
  const chapter = Number(episode.id.split('-')[1]);
  const country = episode.track === 'main' ? COUNTRIES.find(c => c.difficulty === chapter) : undefined;
  if (!cues.length) return [{ id: episode.id, episode, number: String(chapter), title: episode.title, region: episode.location, lines: episode.lines }];
  return cues.map((cue, i) => ({
    id: cue.id, episode, cue, number: `${chapter}-${i + 1}`, title: STORY_MOMENT_LABELS[cue.moment],
    region: country ? `${PROVINCE_BY_ID[country.regions[i < 2 ? 0 : 1]].name} · ${i < 2 ? '前線' : '本城'}` : episode.location,
    lines: episode.lines.slice(cue.start, cue.end + 1),
  }));
});

export function readingSection(episodeId: string, cueId?: string | null, lineId?: string | null) {
  const sections = STORY_SECTIONS.filter(s => s.episode.id === episodeId);
  return sections.find(s => s.id === cueId) ?? sections.find(s => s.lines.some(l => l.id === lineId)) ?? sections[0];
}

export function sectionProgress(progress: StoryProgress, section: StorySection) {
  const own = progress?.[section.id];
  if (own) return own;
  const legacy = progress?.[section.episode.id];
  // 旧全話読了は全場面に継承。途中位置はその台詞の属する場面だけに継承する。
  if (legacy?.complete) return { lineId: section.lines[0].id, complete: true };
  return legacy && section.lines.some(l => l.id === legacy.lineId) ? legacy : undefined;
}

export function sectionTitle(section: StorySection) {
  return section.cue ? `${section.number}　${section.title}` : section.title;
}
